<template>
  <div class="main-page content">
    <div class="container">
      <h2
        class="b-title"
        data-aos="fade-right"
        data-aos-delay="0"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="true"
      >
        Құрметті қолданушылар!
      </h2>
      <div
        class="sertificate-lesson text-wrapper"
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="true"
      >
        <div class="desc">
          <div class="title">
            Сайттың қазақша нұсқасы қазір әзірлену үстінде және жақын арада
            қолжетімді болады. Түсінгеніңізге рахмет!
          </div>
          <router-link to="/" class="link link-wrapper">
            Басты бетке өтіңіз

            <svg
              width="187"
              height="8"
              viewBox="0 0 187 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M186.354 4.35355C186.549 4.15829 186.549 3.84171 186.354 3.64645L183.172 0.464466C182.976 0.269204 182.66 0.269204 182.464 0.464466C182.269 0.659728 182.269 0.976311 182.464 1.17157L185.293 4L182.464 6.82843C182.269 7.02369 182.269 7.34027 182.464 7.53553C182.66 7.7308 182.976 7.7308 183.172 7.53553L186.354 4.35355ZM0 4L0 4.5H186V4V3.5H0L0 4Z"
                fill="white"
              />
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lang-disclaimer'
}
</script>

<style scoped>
.container {
  margin-top: 40px;
  margin-bottom: 100px;
}


.link-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-top: 60px;
}

.link {
  font-weight: 400;
  font-size: 16px;
  color: white;
}
</style>
